import React from 'react';
import "./Home.css";

function Home () {
  return (

    <div className='welcome'>

      <h1>Bienvenue sur mon portfolio !</h1>

      <p> Actuellement en transition vers une carrière de concepteur et développeur d'applications, j'ai récemment réussi ma formation de développeur web et web mobile. Jeune passionnée par le code et toujours en quête de nouvelles solutions, je suis activement à la recherche d'une opportunité d'alternance en Conception et Développement d'Applications (CDA). </p>

      <p> N'hésitez pas à découvrir mes expériences, compétences et projets. Si vous avez des opportunités d'alternance ou souhaitez discuter de collaborations potentielles, je serais ravie d'échanger avec vous. </p> 


    </div>
  )
}

export default Home;